import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { fork } from 'redux-saga/effects';
import createRootReducer from './reducers';
import sagas from './sagas';
function* sagaRunner(allSagas: any) {
    for (const saga of allSagas) {
        yield fork(saga);
    }
}
const sagaMiddleware = createSagaMiddleware();
const history = createBrowserHistory();
const rMiddleware = routerMiddleware(history);
const middleware = [rMiddleware, sagaMiddleware];
const store = createStore(createRootReducer(history), composeWithDevTools(applyMiddleware(...middleware)));
const getStore = () => store;
const getHistory = () => history;
sagaMiddleware.run(sagaRunner, sagas);
export { getStore, getHistory };
